<template>
<div class="chapter">
<div class="inner_page">
<p class="prect" id="List"><a id="pviii"></a><a id="pix"></a>List of Figures <img alt="Zipes" src="images/ornament4.png" style="vertical-align:middle"/></p>
<table>
<colgroup>
<col width="80%"/>
<col width="20%"/>
</colgroup>
<tbody>
<tr>
<td class="no-rule"><p class="toc1"><a href="#/pt1ch1.htm#fig1"><span class="toc1block">1.</span>Eucrates and Pancrates</a></p></td>
<td class="no-rule"><p class="page"><a href="#/pt1ch1.htm#fig1">86</a></p></td>
</tr>
<tr>
<td class="no-rule"><p class="toc1"><a href="#/pt1ch1.htm#fig2"><span class="toc1block">2.</span>The Story of the Brahmin Padmanaba and the Young Hassan</a></p></td>
<td class="no-rule"><p class="page"><a href="#/pt1ch1.htm#fig2">89</a></p></td>
</tr>
<tr>
<td class="no-rule"><p class="toc1"><a href="#/pt1ch2.htm#fig3"><span class="toc1block">3.</span>The Master and His Pupil; or, The Magic Book</a></p></td>
<td class="no-rule"><p class="page"><a href="#/pt1ch2.htm#fig3">106</a></p></td>
</tr>
<tr>
<td class="no-rule"><p class="toc1"><a href="#/pt1ch3.htm#fig4"><span class="toc1block">4.</span>The Rash Magician</a></p></td>
<td class="no-rule"><p class="page"><a href="#/pt1ch3.htm#fig4">118</a></p></td>
</tr>
<tr>
<td class="no-rule"><p class="toc1"><a href="#/pt2ch1.htm#fig5"><span class="toc1block">5.</span>Erysichthon and Mestra</a></p></td>
<td class="no-rule"><p class="page"><a href="#/pt2ch1.htm#fig5">131</a></p></td>
</tr>
<tr>
<td class="no-rule"><p class="toc1"><a href="#/pt2ch1.htm#fig6"><span class="toc1block">6.</span>Maestro Lattantio and His Apprentice Dionigi</a></p></td>
<td class="no-rule"><p class="page"><a href="#/pt2ch1.htm#fig6">145</a></p></td>
</tr>
<tr>
<td class="no-rule"><p class="toc1"><a href="#/pt2ch2.htm#fig7"><span class="toc1block">7.</span>The Nimble Thief and His Master</a></p></td>
<td class="no-rule"><p class="page"><a href="#/pt2ch2.htm#fig7">164</a></p></td>
</tr>
<tr>
<td class="no-rule"><p class="toc1"><a href="#/pt2ch2.htm#fig8"><span class="toc1block">8.</span>The Magic Combat</a></p></td>
<td class="no-rule"><p class="page"><a href="#/pt2ch2.htm#fig8">175</a></p></td>
</tr>
<tr>
<td class="no-rule"><p class="toc1"><a href="#/pt2ch2.htm#fig9"><span class="toc1block">9.</span>The Tuft of Wild Beet</a></p></td>
<td class="no-rule"><p class="page"><a href="#/pt2ch2.htm#fig9">185</a></p></td>
</tr>
<tr>
<td class="no-rule"><p class="toc1"><a href="#/pt2ch2.htm#fig10"><span class="toc1block">10.</span>The Magician and His Servant</a></p></td>
<td class="no-rule"><p class="page"><a href="#/pt2ch2.htm#fig10">194</a></p></td>
</tr>
<tr>
<td class="no-rule"><p class="toc1"><a href="#/pt2ch3.htm#fig11"><span class="toc1block">11.</span>The Twelfth Captain’s Tale</a></p></td>
<td class="no-rule"><p class="page"><a href="#/pt2ch3.htm#fig11">248</a></p></td>
</tr>
<tr>
<td class="no-rule"><p class="toc1"><a href="#/pt2ch3.htm#fig12"><span class="toc1block">12.</span>The Black King of Morocco</a></p></td>
<td class="no-rule"><p class="page"><a href="#/pt2ch3.htm#fig12">255</a></p></td>
</tr>
<tr>
<td class="no-rule"><p class="toc1"><a href="#/pt2ch3.htm#fig13"><span class="toc1block">13.</span>The Magician’s Heart</a></p></td>
<td class="no-rule"><p class="page"><a href="#/pt2ch3.htm#fig13">261</a></p></td>
</tr>
<tr>
<td class="no-rule"><p class="toc1"><a href="#/pt2ch3.htm#fig14"><span class="toc1block">14.</span>The Forest Dweller</a></p></td>
<td class="no-rule"><p class="page"><a href="#/pt2ch3.htm#fig14">275</a></p></td>
</tr>
<tr>
<td class="no-rule"><p class="toc1"><a href="#/pt2ch3.htm#fig15"><span class="toc1block">15.</span>The Mistress of Magic</a></p></td>
<td class="no-rule"><p class="page"><a href="#/pt2ch3.htm#fig15">297</a></p></td>
</tr>
<tr>
<td class="no-rule"><p class="toc1"><a href="#/pt2ch3.htm#fig16"><span class="toc1block">16.</span>The Magician and His Disciple</a></p></td>
<td class="no-rule"><p class="page"><a href="#/pt2ch3.htm#fig16">315</a></p></td>
</tr>
<tr>
<td class="no-rule"><p class="toc1"><a href="#/pt3.htm#fig17"><span class="toc1block">17.</span>Krabat: A Legend from Folklore</a></p></td>
<td class="no-rule"><p class="page"><a href="#/pt3.htm#fig17">325</a></p></td>
</tr>
<tr>
<td class="no-rule"><p class="toc1"><a href="#/pt3.htm#fig18"><span class="toc1block">18.</span>Krabat (1865)</a></p></td>
<td class="no-rule"><p class="page"><a href="#/pt3.htm#fig18">327</a></p></td>
</tr>
<tr>
<td class="no-rule"><p class="toc1"><a href="#/pt3.htm#fig19"><span class="toc1block">19.</span>The Wendish Faust Legend</a></p></td>
<td class="no-rule"><p class="page"><a href="#/pt3.htm#fig19">336</a></p></td>
</tr>
<tr>
<td class="no-rule"><p class="toc1"><a href="#/pt3.htm#fig20"><span class="toc1block">20.</span>Krabat (1959)</a></p></td>
<td class="no-rule"><p class="page"><a href="#/pt3.htm#fig20">345</a></p></td>
</tr>
</tbody>
</table>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// list.vue?23d145b9